import { GtmSupport, loadScript } from "@gtm-support/core";
import { GtmSupport as GtmSupport2, GtmSupport as GtmSupport3, assertIsGtmId, hasScript, loadScript as loadScript2 } from "@gtm-support/core";
import { nextTick } from "vue";
let gtmPlugin;
function install(app, options = { id: "" }) {
  options = { trackOnNextTick: false, ...options };
  gtmPlugin = new GtmSupport(options);
  app.config.globalProperties.$gtm = gtmPlugin;
  if (gtmPlugin.isInBrowserContext()) {
    if (options.vueRouter) {
      initVueRouterGuard(
        app,
        options.vueRouter,
        options.ignoredViews,
        options.trackOnNextTick,
        options.vueRouterAdditionalEventData
      );
    }
    if (gtmPlugin.options.enabled && gtmPlugin.options.loadScript) {
      if (Array.isArray(options.id)) {
        options.id.forEach((id) => {
          if (typeof id === "string") {
            loadScript(id, options);
          } else {
            const newConf = {
              ...options
            };
            if (id.queryParams != null) {
              newConf.queryParams = {
                ...newConf.queryParams,
                ...id.queryParams
              };
            }
            loadScript(id.id, newConf);
          }
        });
      } else {
        loadScript(options.id, options);
      }
    }
  }
  app.provide("gtm", options);
}
function initVueRouterGuard(app, vueRouter, ignoredViews = [], trackOnNextTick, deriveAdditionalEventData = () => ({})) {
  function isNavigationFailure(failure, navigationFailureType) {
    if (!(failure instanceof Error)) {
      return false;
    }
    return !!(failure.type & navigationFailureType);
  }
  vueRouter.afterEach(async (to, from, failure) => {
    var _a, _b, _c;
    if (typeof to.name !== "string" || Array.isArray(ignoredViews) && ignoredViews.includes(to.name) || typeof ignoredViews === "function" && ignoredViews(to, from)) {
      return;
    }
    const name = to.meta && typeof to.meta.gtm === "string" && !!to.meta.gtm ? to.meta.gtm : to.name;
    if (isNavigationFailure(failure, 4)) {
      if (gtmPlugin == null ? void 0 : gtmPlugin.debugEnabled()) {
        console.log(
          `[VueGtm]: '${name}' not tracked due to navigation aborted`
        );
      }
    } else if (isNavigationFailure(failure, 8)) {
      if (gtmPlugin == null ? void 0 : gtmPlugin.debugEnabled()) {
        console.log(
          `[VueGtm]: '${name}' not tracked due to navigation cancelled`
        );
      }
    }
    const additionalEventData = {
      ...await deriveAdditionalEventData(to, from),
      ...(_a = to.meta) == null ? void 0 : _a.gtmAdditionalEventData
    };
    const baseUrl = ((_c = (_b = vueRouter.options) == null ? void 0 : _b.history) == null ? void 0 : _c.base) ?? "";
    let fullUrl = baseUrl;
    if (!fullUrl.endsWith("/")) {
      fullUrl += "/";
    }
    fullUrl += to.fullPath.startsWith("/") ? to.fullPath.substring(1) : to.fullPath;
    if (trackOnNextTick) {
      void nextTick(() => {
        gtmPlugin == null ? void 0 : gtmPlugin.trackView(name, fullUrl, additionalEventData);
      });
    } else {
      gtmPlugin == null ? void 0 : gtmPlugin.trackView(name, fullUrl, additionalEventData);
    }
  });
}
function createGtm(options) {
  return { install: (app) => install(app, options) };
}
const _default = { install };
function useGtm() {
  return gtmPlugin;
}
export {
  GtmSupport2 as GtmPlugin,
  GtmSupport3 as GtmSupport,
  assertIsGtmId,
  createGtm,
  _default as default,
  hasScript,
  loadScript2 as loadScript,
  useGtm
};
